import opencl from "refractor/opencl";
export default opencl;